import { Link } from "react-router";

import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card/hover-card";
import WarningInfoIcon from "@/components/ui/icon/warning-info";

type Props = {
	roomPriceEditPagePath?: string;
};

export const DailyItemHoverWarningCard = ({ roomPriceEditPagePath }: Props) => {
	return (
		<HoverCard>
			<HoverCardTrigger className="absolute right-1 top-1 z-20">
				<WarningInfoIcon className="text-warning-600" size="sm" />
			</HoverCardTrigger>

			<HoverCardContent side={"bottom"} align={"center"} sideOffset={8} className="z-50 w-96">
				<div className="text-left">
					<div className="space-y-2">
						{roomPriceEditPagePath ? (
							<div className="space-y-6">
								<p>部屋の料金が設定されていません。</p>

								<div className="space-y-6">
									<div className="space-y-2">
										<p className="text-[15px] font-semibold">CHILLNNで料金を管理している場合</p>

										<div className="space-y-3">
											<ul className="list-disc pl-4">
												<li>
													<Link
														to={roomPriceEditPagePath}
														target="_blank"
														className="text-link-400 underline-offset-4 hover:underline"
														viewTransition
													>
														料金ランク
													</Link>
													から料金を設定してください
												</li>
											</ul>

											<p className="text-sm text-brand">
												※紐付けているプランで "定額部屋料金"
												を設定している場合は、そのプランでのみ販売されます。
											</p>
										</div>
									</div>
									<div className="space-y-2">
										<p className="text-[15px] font-semibold">
											サイトコントローラーで料金を管理している場合
										</p>
										<ul className="list-disc pl-4">
											<li>
												<p>サイトコントローラーの管理画面から料金を設定してください</p>
											</li>
										</ul>
									</div>
								</div>
							</div>
						) : (
							<p>料金設定画面から料金の設定をしてください。</p>
						)}
					</div>
				</div>
			</HoverCardContent>
		</HoverCard>
	);
};
